var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Headerr'),_c('KeepAlive',[_c('router-view')],1),_c('Foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }